const openInNewWindow = (url) => {
    window.open(url,"_blank")
  }



export {openInNewWindow};